import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
  const location = useLocation();

  const pathnames = location.pathname
    .split("/")
    .filter((x) => x);

  return (
    <div className="hero-path">

      <Link to="/">HOME</Link>

      {pathnames.map((name, index) => {
        const routeTo =
          "/" + pathnames.slice(0, index + 1).join("/");

        const isLast =
          index === pathnames.length - 1;

        return (
          <span key={name}>
            {" / "}

            {isLast ? (
              <span className="active-path">
                {name.replace(/-/g, " ").toUpperCase()}
              </span>
            ) : (
              <Link to={routeTo}>
                {name.replace(/-/g, " ").toUpperCase()}
              </Link>
            )}
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumb;